// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-request-update-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}
.songwriter-request-update-wrapper p {
  font-size: 1.4rem;
}
.songwriter-request-update-wrapper div textarea {
  margin-top: 1rem;
  width: 100%;
  height: 10rem;
}
.songwriter-request-update-wrapper .select-component {
  width: 28rem;
}
.songwriter-request-update-wrapper .button-component {
  align-self: flex-end;
}
.songwriter-request-update-wrapper .text-label {
  color: #4f4f4f;
}
.songwriter-request-update-wrapper .review-information {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
.songwriter-request-update-wrapper .footer-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAIE;EACE,oBAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AALJ","sourcesContent":[".songwriter-request-update-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n\n  p {\n    font-size: 1.4rem;\n  }\n\n  div textarea {\n    margin-top: 1rem;\n    width: 100%;\n    height: 10rem;\n  }\n\n  .select-component {\n    width: 28rem;\n  }\n\n  .button-component {\n    align-self: flex-end;\n  }\n\n  .text-label {\n    color: #4f4f4f;\n  }\n\n  .review-information {\n    display: flex;\n    flex-direction: column;\n    gap: 3rem;\n  }\n\n  .footer-buttons {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
